const API_URL = process.env.REACT_APP_API_URL || 'https://kolinapi.obiziz.website';

// Debug için API URL'i konsola yazdır
console.log('API_URL:', API_URL);
console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

class ApiService {
  constructor() {
    this.baseURL = API_URL;
    console.log('ApiService baseURL:', this.baseURL);
  }

  // Token'ı localStorage'dan al
  getToken() {
    return localStorage.getItem('userToken');
  }

  // API isteği için header'ları hazırla
  getHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  }

  // GET isteği
  async get(endpoint) {
    try {
      const response = await fetch(`${this.baseURL}${endpoint}`, {
        method: 'GET',
        headers: this.getHeaders()
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('API GET error:', error);
      throw error;
    }
  }

  // POST isteği
  async post(endpoint, data) {
    try {
      const response = await fetch(`${this.baseURL}${endpoint}`, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('API POST error:', error);
      throw error;
    }
  }

  // PUT isteği
  async put(endpoint, data) {
    try {
      const response = await fetch(`${this.baseURL}${endpoint}`, {
        method: 'PUT',
        headers: this.getHeaders(),
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('API PUT error:', error);
      throw error;
    }
  }

  // DELETE isteği
  async delete(endpoint) {
    try {
      const response = await fetch(`${this.baseURL}${endpoint}`, {
        method: 'DELETE',
        headers: this.getHeaders()
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('API DELETE error:', error);
      throw error;
    }
  }

  // Auth API'leri
  async login(email, password) {
    return this.post('/api/auth/login', { email, password });
  }

  async getProfile() {
    return this.get('/api/auth/profile');
  }

  async updateProfile(data) {
    return this.put('/api/auth/profile', data);
  }

  async changePassword(currentPassword, newPassword) {
    return this.put('/api/auth/change-password', { currentPassword, newPassword });
  }

  async uploadAvatar(file) {
    const formData = new FormData();
    formData.append('avatar', file);

    const response = await fetch(`${this.baseURL}/api/auth/avatar`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${this.getToken()}`
      },
      body: formData
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  }

  async deleteAvatar() {
    return this.delete('/api/auth/avatar');
  }

  // Announcement API'leri
  async getAnnouncements(filters = {}) {
    const queryString = new URLSearchParams(filters).toString();
    return this.get(`/api/announcements${queryString ? `?${queryString}` : ''}`);
  }

  async getAnnouncement(id) {
    return this.get(`/api/announcements/${id}`);
  }

  async createAnnouncement(data) {
    return this.post('/api/announcements', data);
  }

  async updateAnnouncement(id, data) {
    return this.put(`/api/announcements/${id}`, data);
  }

  async deleteAnnouncement(id) {
    return this.delete(`/api/announcements/${id}`);
  }

  async toggleAnnouncementLike(id) {
    return this.post(`/api/announcements/${id}/like`);
  }

  async addAnnouncementComment(id, content) {
    return this.post(`/api/announcements/${id}/comment`, { content });
  }

  // User API'leri
  async getUsers(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.get(`/api/users${queryString ? `?${queryString}` : ''}`);
  }

  async getUserById(id) {
    return this.get(`/api/users/${id}`);
  }

  async updateUser(id, data) {
    return this.put(`/api/users/${id}`, data);
  }

  async deleteUser(id) {
    return this.delete(`/api/users/${id}`);
  }

  async getDepartments() {
    return this.get('/api/users/departments');
  }

  async getUserStats() {
    return this.get('/api/users/stats');
  }

  // Announcement API'leri
  async getAnnouncements(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.get(`/api/announcements${queryString ? `?${queryString}` : ''}`);
  }

  async getAnnouncementById(id) {
    return this.get(`/api/announcements/${id}`);
  }

  async createAnnouncement(data) {
    return this.post('/api/announcements', data);
  }

  async updateAnnouncement(id, data) {
    return this.put(`/api/announcements/${id}`, data);
  }

  async deleteAnnouncement(id) {
    return this.delete(`/api/announcements/${id}`);
  }

  async likeAnnouncement(id) {
    return this.post(`/api/announcements/${id}/like`);
  }

  async commentAnnouncement(id, content) {
    return this.post(`/api/announcements/${id}/comment`, { content });
  }

  // Document methods
  async getDocuments(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.get(`/api/documents?${queryString}`);
  }

  async getDocument(id) {
    return this.get(`/api/documents/${id}`);
  }

  async createDocument(data) {
    return this.post('/api/documents', data);
  }

  async updateDocument(id, data) {
    return this.put(`/api/documents/${id}`, data);
  }

  async deleteDocument(id) {
    return this.delete(`/api/documents/${id}`);
  }

  async uploadDocument(file, title = '', description = '') {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('title', title);
    formData.append('description', description);

    const response = await fetch(`${this.baseURL}/api/documents/upload`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${this.getToken()}`
      },
      body: formData
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  }

  // User methods
  async getAllUsers() {
    const response = await fetch(`${this.baseURL}/api/users`, {
      headers: {
        'Authorization': `Bearer ${this.getToken()}`
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  }

  // Count methods
  async getCounts() {
    return this.get('/api/count');
  }

  // HR methods
  async getHRStats() {
    return this.get('/api/hr/stats');
  }

  async getRecentApplications() {
    return this.get('/api/hr/recent-applications');
  }

  async getRecentNewEmployees() {
    return this.get('/api/hr/recent-employees');
  }

  async getLeaveRequests(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.get(`/api/hr/leave-requests${queryString ? `?${queryString}` : ''}`);
  }

  async getExpenseReports(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.get(`/api/hr/expense-reports${queryString ? `?${queryString}` : ''}`);
  }

  // Application Management
  async approveApplication(id, type, approverId) {
    return this.put(`/api/hr/applications/${id}/${type}/approve`, { approverId });
  }

  async rejectApplication(id, type, approverId, reason) {
    return this.put(`/api/hr/applications/${id}/${type}/reject`, { approverId, reason });
  }

  // Yeni çalışan oluşturma
  async createEmployee(employeeData) {
    const response = await fetch(`${this.baseURL}/api/users/employee`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getToken()}`
      },
      body: JSON.stringify(employeeData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Çalışan oluşturulurken hata oluştu');
    }

    return await response.json();
  }

  // Inventory Management
  async getInventory(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    return this.get(`/api/inventory${queryString ? `?${queryString}` : ''}`);
  }

  async getInventoryStats() {
    return this.get('/api/inventory/stats');
  }

  async createInventoryItem(itemData) {
    return this.post('/api/inventory', itemData);
  }

  async updateInventoryItem(id, itemData) {
    return this.put(`/api/inventory/${id}`, itemData);
  }

  async deleteInventoryItem(id) {
    return this.delete(`/api/inventory/${id}`);
  }

  async getInventoryItemById(id) {
    return this.get(`/api/inventory/${id}`);
  }
}

export default new ApiService();
